import React from 'react';

interface NaverIconProps {
  width?: number;
  height?: number;
  className?: string;
}

const NaverIcon: React.FC<NaverIconProps> = ({ 
  width = 20, 
  height = 20, 
  className = "" 
}) => {
  return (
    <svg 
      viewBox="0 0 24 24" 
      width={width} 
      height={height}
      className={className}
    >
      <path fill="#03C75A" d="M16.273 12.845L7.376 0H0v24h7.727V11.155L16.624 24H24V0h-7.727v12.845z"/>
    </svg>
  );
};

export default NaverIcon;
